import React, { useCallback } from 'react'
import { Field, useFormikContext } from 'formik'

import { useFeatureEnabled } from 'civic-champs-shared/feature/hooks'
import { StyledKeyboardTimePicker } from '../../../civic-champs-shared/formik/components/StyledFormikDateTimePickers'
import { useAddEditEventStyles } from '../../hooks/useAddEditEventStyles'
import moment from 'moment'
import { EventDateScreenValues } from '../EventDateAndRoleScreen'
import DatePickerMultiSelect from '../date-picker-multi-select-new'

export function SchedulableEditBlock() {
  const classes = useAddEditEventStyles()
  const isMoveDateEnabled = useFeatureEnabled('EditEventSequenceInfo')

  const formik = useFormikContext<EventDateScreenValues>()

  const handleEventDateChange = useCallback(
    (newValue: Date) => {
      const { values, setFieldValue } = formik

      const startTime = moment(values.startTime)
      const endTime = moment(values.endTime)

      const newStartsAt = moment(newValue)
        .startOf('day')
        .set('hours', startTime.hours())
        .set('minutes', startTime.minutes())

      const newEndsAt = newStartsAt
        .clone()
        .startOf('day')
        .set('hours', endTime.hours())
        .set('minutes', endTime.minutes())
        .toDate()

      setFieldValue('startDate', newStartsAt.toDate())
      setFieldValue('startTime', newStartsAt.toDate())
      setFieldValue('endDate', newEndsAt)
      setFieldValue('endTime', newEndsAt)
    },
    [formik],
  )

  const handleDatePickerChange = useCallback(
    (dateStr: string) => {
      handleEventDateChange(moment(dateStr, 'MM/DD/YYYY').toDate())
    },
    [handleEventDateChange],
  )

  const selectedDates = formik.values.startDate ? [formik.values.startDate] : []

  return (
    <>
      <div className={classes.dateTimePickers}>
        <div className={classes.dateTimePicker}>
          <Field
            inputVariant="outlined"
            label="Start Time"
            higher
            component={StyledKeyboardTimePicker}
            name="startTime"
          />
        </div>

        <div className={classes.dateTimePicker}>
          <Field higher inputVariant="outlined" label="End Time" component={StyledKeyboardTimePicker} name="endTime" />
        </div>
      </div>

      <div className={classes.dateTimePickers}>
        <DatePickerMultiSelect
          label="Event Date"
          placeholder="Select Event Date"
          datesOnScreen={1}
          dates={selectedDates}
          onChange={handleDatePickerChange}
          isDisabled={!isMoveDateEnabled}
          minDate={moment().format('MM/DD/YYYY')}
        />
      </div>
    </>
  )
}
